module.exports = __webpack_public_path__ + "media/images/_hotel-equipment-2ee54eef5873fd037f1da698020c6e54.png";